import { List as RaList, ListProps as RaListProps } from 'react-admin';

export const List = RaList;

export type ListProps = RaListProps;
